import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useStore, extractErrorMessage } from "../../../helpers";
import { TARS_SOURCE_UPDATE_PATH } from "../tars-constants";
import { markTarsNotebookActivity } from "./tars-notebook-last-touched";

/**
 * POST /tars/source/update — OpenAPI body:
 * notebook_id, type, parent_id, s3_key, name, mime_type, size_bytes, tags, more, source_id
 */
export interface UpdateSourcePayload {
  notebook_id: number;
  type: string;
  parent_id: number;
  s3_key: string;
  name: string;
  mime_type: string;
  size_bytes: number;
  tags: string[];
  more: Record<string, unknown>;
  source_id: number;
}

export const useUpdateSource = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateSourcePayload): Promise<unknown> => {
      const body = {
        notebook_id: payload.notebook_id,
        type: payload.type,
        parent_id: payload.parent_id,
        s3_key: payload.s3_key,
        name: payload.name,
        mime_type: payload.mime_type,
        size_bytes: payload.size_bytes,
        tags: payload.tags,
        more: payload.more,
        source_id: payload.source_id,
      };
      const res = await rootStore.apiRequestHandler(
        TARS_SOURCE_UPDATE_PATH,
        body,
        "Failed to update source"
      );
      return res.data ?? res;
    },
    onSuccess: (_data, variables) => {
      toast.success("Source updated");
      markTarsNotebookActivity(queryClient, variables.notebook_id);
      queryClient.invalidateQueries({ queryKey: ["tars", "source", "list"] });
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to update source"));
    },
  });
};
